import React from 'react';

import AutenticarService from '../service/AutenticarService';
import UsuarioService from '../service/UsuarioService';

import FormCodeEnum from '../helper/enumerador/FormCodeEnum';

import { getAppUrl } from '../helper/Url';
import {route} from '../helper/Route';

class AbstractComponent extends React.Component {         
    P_ERRO_PADRAO() {
        return 'Ocorreu um erro inesperado, tente novamente mais tarde!';
    }                   

    isLogged() {                                
        return !(AutenticarService.getToken() === '' || AutenticarService.getToken() === undefined || AutenticarService.getToken() === null);
    }    

    autenticar() {           
        if(!this.isLogged()) {                     
            this.props.route(this.login());
            return false;
        }              
        
        return true;
    }    

    finalizaErro(erro) {        
        if(erro.code === FormCodeEnum.SEND_TO_LOGIN) {
            return this.props.route(this.login());
        }

        erro.message = '';
        erro.code = 0;

        return erro;
    }

    trataErro(erro) {        
        let erroTxt = '';        
        let code = 400;
                
        if((erro === undefined || erro.response === undefined || erro.response.data === undefined || erro.response.data === '')) {                                
            return {
                message: this.P_ERRO_PADRAO(),
                code: code
            }
        }        
                
        erroTxt = erro.response.data; 
        code = erro.response.status;             

        if((erroTxt === '')||(erroTxt === undefined)||(erroTxt === ''))
            return {
                message: this.P_ERRO_PADRAO(),
                code: code
            }

        if((typeof erroTxt) === 'object') {
            if(erroTxt.message !== undefined && erroTxt.message === 'Slim Application Error')
                return {
                    message: this.P_ERRO_PADRAO(),
                    code: code
                }
                
            return {
                message: erroTxt,
                code: code
            }        
        }

        let pos = erroTxt.indexOf('"');                                

        if(pos === -1)
            return {
                message: erroTxt,
                code: code
            };
            
        if(pos === 0)            
            erroTxt = erroTxt.substring(1, erroTxt.length);        
            
        pos = erroTxt.indexOf('"');                    
        
        if(pos > -1)
            erroTxt = erroTxt.substring(0, pos);                
            
        return {
            message: erroTxt,
            code: code
        }
    }

    login() {    
        AutenticarService.logout();
                                
        return route(
            '',
            'Login',
            'login'
        );
    }

    homePage() {                
        return route(
            '',
            'HomePage',
            ''
        );        
    }

    homePage2() {        
        window.location.href = getAppUrl();
    }    

    areaAdminMsg() {                                
        // return route(
        //     '',
        //     'Área Restrita',
        //     'area-restrita'
        // ); 
        return this.login();
    }

    addMenu(icone, nome, link) {
        let menu = {};

        menu.icone = icone;
        menu.nome = nome;
        menu.link = link;

        return menu;
    }

    logout() {        
        UsuarioService.logout().then(() => {            
            AutenticarService.logout();
            
            this.setState({preload: false});

            this.homePage2();                    
        }).catch(() => {                
            AutenticarService.logout();                               
        });
    }

    foco(nome) {                           
        var el = document.getElementById(nome);                        

        if((el === undefined)||(el === null))
            return ;            

        el.focus();        
    }       
}

export default AbstractComponent;